module.exports = __webpack_public_path__ + "img/img-success.f6da26a6.png";